import { Mission } from '../mission'
import * as skylineApi from '../skylineApi'
import * as adminFeed from '../adminFeed'

const missions = {}

export function getMission(id) {
	if (missions[id]) return missions[id]

	const data = skylineApi.getMission(id)
	const mission = new Mission(data)
	missions[id] = mission
	
	return mission
}

export function clearMission(mission) {
	const id = mission.serverState.id
	if (!missions[id]) return
	mission.cleanup()
	delete missions[id]
}

adminFeed.register('mission', missionUpdate)

function missionUpdate(message) {
	if (!message.mission || message.action !== 'UPDATE') return

	if (!missions[message.mission.id]) return
	const mission = missions[message.mission.id]
	mission.updateServerState(message.mission)
	console.log('New mission state', message.mission)
	if (mission.isLive && !mission.isConnected) {
		console.log('Connecting to live mission')
		mission.connect()
	} else if (!mission.isLive && mission.isConnected) {
		console.log('Disconnecting mission')
		mission.disconnect()
	}
}